import axios from 'axios'

//export function versionWatcher(intervalMs = 30000) {
//    let currentVersion = null
//
//    const checkVersion = async () => {
//        try {
//            const res = await axios.get('/api/version')
//            const newVersion = res.data.version
//
//            if (currentVersion && newVersion !== currentVersion) {
//                location.reload()
//            }
//
//            currentVersion = newVersion
//        } catch (e) {
//            console.warn('Version check failed (likely deploy in progress):', e)
//        }
//    }
//
//    // Run immediately and then poll at intervals
//    checkVersion()
//    setInterval(checkVersion, intervalMs)
//}
export function versionWatcher(intervalMs = 60000) {
    let currentVersion = null;

    const checkVersion = async () => {
        try {
            const res = await axios.get("/api/version", {
                validateStatus: () => true, // Prevent axios throwing on non-2xx
            });

            if (res.status === 503) {
                console.warn("[VersionWatcher] App in maintenance mode — skipping version check.");
                return;
            }

            if (res.status !== 200) {
                console.warn(`[VersionWatcher] Unexpected status ${res.status} from /api/version`);
                return;
            }

            const newVersion = res.data.version;

            if (currentVersion && newVersion !== currentVersion) {
                console.log(`[VersionWatcher] Version changed: ${currentVersion} → ${newVersion} — reloading page`);
                location.reload();
            }

            currentVersion = newVersion;
        } catch (e) {
            console.warn("[VersionWatcher] Failed to check app version:", e.message);
        }
    };

    // Run immediately and then at intervals
    checkVersion();
    setInterval(checkVersion, intervalMs);
}
